// SPDX-License-Identifier: LicenseRef-Techsafe-Proprietary
// Copyright (c) 2026 Techsafe Teknoloji ve Muhendislik A.S.
// https://techsafe-solutions.com
// Economic rights: Techsafe A.S.
// Authors' moral rights reserved under Turkish Copyright Law (FSEK 5846).
// Mali haklar Techsafe A.S.'ye aittir; eser sahiplerinin manevi haklari saklidir (FSEK 5846).
// This content was prepared with the assistance of AI tools, reviewed by a
// human, and published by Techsafe Teknoloji ve Muhendislik A.S. The publishing
// entity is responsible for accuracy and compliance.
// Bu icerik, yapay zeka destekli araclar kullanilarak hazirlanmis, insan
// incelemesinden gecirilmis ve Techsafe Teknoloji ve Muhendislik A.S.
// tarafindan yayimlanmistir. Icerigin dogrulugundan yayimlayan kurulus
// sorumludur.

// ADR-003 D1: single search box, auto-detected identifier type. A software id
// has the ecosystem UUID shape; anything else is treated as a serial number.
//
// IMPORTANT (ADR-003 D2/D3): detection here is a CLIENT-SIDE CONVENIENCE for
// hinting/telemetry only — it is NOT a gate. Authoritative type detection and
// resolution run server-side over the bridge; the widget sends the raw typed
// value as a reference regardless of what this guesses. A wrong guess simply
// becomes an ordinary unresolved outcome, reported (never silently wrong).

export type IdentifierGuess = "software-id" | "serial-number";

const UUID_RE =
  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

export function guessIdentifierType(raw: string): IdentifierGuess {
  return UUID_RE.test(raw.trim()) ? "software-id" : "serial-number";
}
